import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import NeverJoinedComp from './NeverJoinedComp'

function NeverJoined() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <NeverJoinedComp/>      
        </div>
    </div>
  )
}

export default NeverJoined